import { MediaLayer } from "./MediaLayer";
import type { HeroData } from "./schemas";

export default function Hero(props: HeroData) {
  const align = props.alignment ?? "left";
  return (
    <section className="mobile-hero relative w-full overflow-hidden vignette aspect-[4/5] sm:aspect-[16/10] max-h-[78svh]">
      <MediaLayer media={props.media} alt={props.title || "hero"} priority />
      <div className="mobile-hero-scrim" />
      <div
        className={`mobile-hero-copy px-7 flex flex-col ${
          align === "center" ? "items-center text-center" : "items-start"
        }`}
      >
        {props.kicker && (
          <div className="mobile-hero-kicker text-[10px] tracking-[0.4em] uppercase mb-3 text-shadow-soft">
            {props.kicker}
          </div>
        )}
        {props.title && (
          <h1 className="mobile-hero-title font-serif text-4xl sm:text-5xl leading-[1.05] text-shadow-soft max-w-[16ch] whitespace-pre-line">
            {props.title}
          </h1>
        )}
        {props.subtitle && (
          <p className="mobile-hero-subtitle mt-3 text-sm sm:text-base font-light max-w-[42ch] text-shadow-soft">
            {props.subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
